import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";
import validator from "email-validator";
import { confirmAlert } from "react-confirm-alert";

class EmailField extends Component {
  handleChange(e) {
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      e.target.value
    );
  }

  onBlur() {
    if (this.props.element_value !== "") {
      if (!validator.validate(this.props.element_value.trim())) {
        const options = {
          title: "Invalid email address",
          message: "Please enter a valid email address",
          buttons: [
            {
              label: "OK",
              onClick: () => {
                setTimeout(() => {
                  this.emailInput.focus();
                }, 100);
              }
            }
          ]
        };

        confirmAlert(options);
      }
    }
  }

  renderInput() {
    const { element_value, validate, error, ...formControl } = this.props;
    var maxLength = formControl.element_params.H;

    if (validate && error) {
      return (
        <input
          ref={input => {
            this.emailInput = input;
          }}
          onBlur={() => this.onBlur()}
          type="text"
          className="error"
          maxLength={maxLength}
          value={element_value}
          onChange={this.handleChange.bind(this)}
        />
      );
    }

    return (
      <input
        ref={input => {
          this.emailInput = input;
        }}
        onBlur={() => this.onBlur()}
        type="text"
        value={element_value}
        maxLength={maxLength}
        onChange={this.handleChange.bind(this)}
      />
    );
  }

  render() {
    const { element_prompt, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <div>{this.renderInput()}</div>
        </Form.Field>
      </div>
    );
  }
}

EmailField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default EmailField;



// WEBPACK FOOTER //
// ./src/components/EmailField/index.js